import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Table } from 'react-bootstrap';
import { FaFileDownload, FaChartLine } from 'react-icons/fa';
import axios from 'axios';

const GymReports = () => {
  const [reportType, setReportType] = useState('revenue');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [reportData, setReportData] = useState(null);

  const generateReport = async () => {
    try {
      const res = await axios.get(`/api/gym/reports/${reportType}`, {
        params: { dateFrom, dateTo }
      });
      setReportData(res.data);
    } catch (err) {
      console.error(err);
      alert('Error generating report');
    }
  };

  const downloadReport = () => {
    if (!reportData || reportData.length === 0) return;
    
    const headers = Object.keys(reportData[0]).join(',');
    const rows = reportData.map(r => Object.values(r).join(','));
    const csv = [headers, ...rows].join('\n');
    
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `gym-${reportType}-${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Container fluid className="py-4">
      <h2 className="mb-4">📊 Gym Reports</h2>

      <Card className="shadow-sm mb-4">
        <Card.Body>
          <Row>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>Report Type</Form.Label>
                <Form.Select value={reportType} onChange={(e) => setReportType(e.target.value)}>
                  <option value="revenue">Revenue Report</option>
                  <option value="attendance">Attendance Report</option>
                  <option value="members">Member Growth</option>
                  <option value="packages">Package-wise Revenue</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>From Date</Form.Label>
                <Form.Control type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>To Date</Form.Label>
                <Form.Control type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Label>&nbsp;</Form.Label>
              <div>
                <Button variant="primary" onClick={generateReport}>
                  <FaChartLine className="me-2" /> Generate
                </Button>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {reportData && (
        <Card className="shadow-sm">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <strong>{reportType.toUpperCase()} Report</strong>
            <Button variant="success" size="sm" onClick={downloadReport}>
              <FaFileDownload className="me-2" /> Download CSV
            </Button>
          </Card.Header>
          <Card.Body>
            <Table responsive hover>
              <thead>
                <tr>
                  {reportData[0] && Object.keys(reportData[0]).map(key => (
                    <th key={key}>{key}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {reportData.map((row, idx) => (
                  <tr key={idx}>
                    {Object.values(row).map((val, i) => (
                      <td key={i}>{val}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};

export default GymReports;
